const Mixins = {
    data() {
        return {

        }
    },
    created() {
        // // console.log('混入对象的钩子被调用')
    },
    methods:{
        upDateUserInfo(userInfo){
            let {userId,token,userName} = userInfo;
            this.$store.commit("updateUserId",userId);
            this.$store.commit("updateToken",token);
            this.$store.commit("updateUserName",userName);
        }
    }
}
export default Mixins; 